import React from 'react';
import { Fieldset, FieldFeedback, Legend, Hint, Radio } from '@piggybank/form';
import { Heading, VisuallyHidden, Paragraph } from '@piggybank/core';
import { Translation, Optional } from 'srcAlias/client/locale';
import T from 'prop-types';
import { getProductTypeLabels } from './getProductTypeLabels';
import { get } from 'lodash-es';

export const ProductDetailsList = ({
  eligibleProducts,
  hasEquitiesProduct,
}) => (
  <>
    {hasEquitiesProduct && (
      <Heading level={2} accentBar>
        <Translation path="productDetailsHeading" />
      </Heading>
    )}
    <Fieldset marginBottom={6} name="product">
      <Paragraph lead>
        <Translation path="subHeading" />
      </Paragraph>
      <Optional>
        <VisuallyHidden>
          <Legend>
            <Translation path="subHeadingAccessibility" />
          </Legend>
        </VisuallyHidden>
      </Optional>
      <Optional>
        <Hint>
          <Translation path="subHeadingHint" />
        </Hint>
      </Optional>
      {eligibleProducts.map((item, index) => (
        <Radio
          value={`${item.productCode}_${item.productCategory}`} //IN1_UNIT_TRUST --> UT_HBSP_UNIT_TRUST
          fullWidth={true}
          key={index}
        >
          <Translation
            path={get(
              getProductTypeLabels,
              `${item.productCode}_${item.productCategory}.labelText`,
              ''
            )}
          />
          <Hint>
            <Translation
              path={get(
                getProductTypeLabels,
                `${item.productCode}_${item.productCategory}.helpText`,
                ''
              )}
            />
          </Hint>
        </Radio>
      ))}
      <FieldFeedback />
    </Fieldset>
  </>
);

ProductDetailsList.propTypes = {
  eligibleProducts: T.array,
  hasEquitiesProduct: T.bool,
};
